import React, {Component} from 'react'
import ReactDom from 'react-dom'
import Filter from './components/filter'
import Grid from './components/grid'
import Modal from './components/modal'
import Pagination from './components/pagination'
import Search from './components/search'

class App extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            posts: [],
            cities: [],
            searchString: '',
            currentCity: 'Ort',
            currentPerson: {},
            page: 1,
        }
        
        this.setPage = this.setPage.bind(this)
        this.setSearchString = this.setSearchString.bind(this)
        this.setCurrentCity = this.setCurrentCity.bind(this)
        this.setCurrentPerson = this.setCurrentPerson.bind(this)
        this.clearCurrentPerson = this.clearCurrentPerson.bind(this)
        
        this.ITEMS_PER_PAGE = 12
    }
    
    componentDidMount() {
        jQuery.ajax({
            method: 'POST',
            url: window.MS_Ajax.ajaxurl,
            data: {
                action: 'get-employees',
            },
        })
          .done((data) => {
              if (data.length) {
                  this.setState({ posts: data })
                  
                  const citiesArr = data.reduce((cities, el) => [...cities, ...el.city.map(city => city.name)], [])
                  this.setState({
                      cities: ['Ort', ...[...new Set(citiesArr)]],
                  })
              }
          })
    }
    
    setPage(pageNumber) {
        this.setState({
            page: pageNumber,
        })
    }
    
    setSearchString(event) {
        this.setState({
            searchString: event.target.value.toLowerCase(),
            currentCity: 'Ort',
            page: 1,
        })
    }
    
    setCurrentCity(cityName) {
        this.setState({
            currentCity: cityName,
            page: 1,
            searchString: '',
        })
    }
    
    setCurrentPerson(person) {
        this.setState({ currentPerson: person })
    }
    
    clearCurrentPerson() {
        this.setState({ currentPerson: {} })
    }
    
    filterPosts(posts, page, searchString, currentCity) {
        return posts.filter(({
                                 name,
                                 city,
                             }) => {
            name = name.toLowerCase()
            if (currentCity === 'Ort' && !searchString) {
                return true
            } else if (searchString && name.includes(searchString)) {
                return true
            } else if (city.some(el => el.name === currentCity)) {
                return true
            }
            return false
        })
    }
    
    render() {
        const {
            posts,
            cities,
            searchString,
            currentCity,
            currentPerson,
            page,
        } = this.state
        const isActiveModal = Object.keys(currentPerson).length > 0
        const fileteredPost = this.filterPosts(posts, page, searchString, currentCity)
        const postsLength = fileteredPost.length
        const slicedPosts = fileteredPost.slice((page - 1) * this.ITEMS_PER_PAGE, page * this.ITEMS_PER_PAGE)
        return (
          <div>
              <div className="consultants__nav">
                  {cities.length
                   ? <Filter
                     cities={cities}
                     currentCity={currentCity}
                     onChange={this.setCurrentCity}
                   />
                   : ''
                  }
                  <Search
                    value={searchString}
                    onChange={this.setSearchString}/>
              </div>
              <Grid
                posts={slicedPosts}
                onSelect={this.setCurrentPerson}/>
              <Pagination
                postsPerPage={this.ITEMS_PER_PAGE}
                postsLength={postsLength}
                page={page}
                changePage={this.setPage}/>
              <Modal
                person={currentPerson}
                isActive={isActiveModal}
                onClose={this.clearCurrentPerson}/>
          </div>
        )
    }
}

ReactDom.render(<App/>, document.querySelector('.consultants__container'))
